import * as React from "react";

import connectToList from "../../store/list";

import GenControlsBar from "../Gen/ControlsBar";
import GenMore from "../Gen/More";
import GenSearchBox from "../Gen/SearchBox";

import DocumentSummary from "../Document/Summary";

interface CategoryDocumentListProps {
  category_id: number;
  categoryDocuments: ConnectedList<DocumentSnakeModel>;
  currentUser: UserSnakeModel,
  currentRoleDefinition: RoleDefinitionSnakeModel
}

function CategoryDocumentList(props: CategoryDocumentListProps) {
  const {
    category_id,
    categoryDocuments,
    currentUser,
    currentRoleDefinition,
  } = props;

  React.useEffect(() => {
    categoryDocuments.mountList(`/categories/${category_id}/category_documents`);
  }, []);

  return (
    <div>
      <GenControlsBar>
        <GenSearchBox
          {...categoryDocuments}
        />
      </GenControlsBar>
      <div className="gen-list-grid">
        {categoryDocuments.listData?.map((categoryDocuments) => (
          <DocumentSummary
            key={categoryDocuments.id}
            document={categoryDocuments}
            canAddFromSummary
            currentUser={currentUser}
            currentRoleDefinition={currentRoleDefinition}
            categoryId={category_id}
          />
        ))}
      </div>
      <GenMore
        {...categoryDocuments}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(CategoryDocumentList, ["categoryDocuments"]);
